export default __webpack_public_path__ + "static/media/shuffle-icon.27242fd6.svg";